import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11.552 16.058a4.51 4.51 0 0 0 4.506 4.507 4.51 4.51 0 0 0 4.507-4.507 4.51 4.51 0 0 0-4.507-4.506 4.51 4.51 0 0 0-4.506 4.506"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M26.435 10.11a.2.2 0 0 0-.002-.199 12.1 12.1 0 0 0-4.32-4.282A12.05 12.05 0 0 0 16.058 4a12 12 0 0 0-9.426 4.54.2.2 0 0 0-.017.221l3.394 5.88a.198.198 0 0 0 .363-.05 5.87 5.87 0 0 1 6.213-4.381h9.678a.2.2 0 0 0 .172-.1"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17.84 21.786a.2.2 0 0 0-.21-.07 6 6 0 0 1-1.572.215 5.9 5.9 0 0 1-5.325-3.399l-4.842-8.386a.198.198 0 0 0-.343.002 12.065 12.065 0 0 0 1.404 13.816 12.06 12.06 0 0 0 7.337 4.022c.07 0 .135-.037.17-.099l3.396-5.88a.2.2 0 0 0-.015-.221"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M27.103 11.528h-6.798a.198.198 0 0 0-.138.338 5.83 5.83 0 0 1 1.764 4.191 5.83 5.83 0 0 1-1.058 3.359l-4.85 8.401a.198.198 0 0 0 .17.297h.003a12 12 0 0 0 8.434-3.576 11.98 11.98 0 0 0 3.487-8.481 12 12 0 0 0-.83-4.404.2.2 0 0 0-.184-.126"
    }
  )
);
var SvgChromeFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChromeFilled_default = SvgChromeFilled;

export { ChromeFilled_default as default };
